export const enum SCROLL_TO_ID {
  intro = 'intro',
  branding = 'branding',
  faq = 'faq',
  feedback = 'feedback',
  footer = 'footer',
  videoSection = 'opening-video',
  openingSection = 'opening',
  pickPointKinds = 'pick-point-kinds',
  heroHome = 'home',
  heroForm = 'opening-form',
  conferencePageToday = 'today',
  authForm = 'authForm',
  authFormMobile = 'authFormMobile'
}

export const SECTIONS_IDS = [1, 2, 3, 4, 5, 6, 7]

export const MILLISECONDS_IN_DAY = 86400000

export const APP_PREFIX = 'promo'

export const colors = {
  corp: '#cb11ab',
  corpLight: '#FFE6F7',
  corpMain: '#ad49fb',
  secondary: 'rgb(0 0 0 / 45%)',
  gray: '#00000073',
  grayLight: 'rgb(128 128 128 / 15%)',
  grayLightHover: 'rgb(128 128 128 / 6.8%)',
  red: '#eb3546',
  orange: '#E47A00',
  black: '#090909',
  green: '#1ea52d',
  white: '#FFFFFF',
  darkAnt: '#001529',
  info: '#7b61ff',
  whiteLight: 'rgba(255, 255, 255, 0.42)',
}

export const DATE_FORMAT_DEFAULT = 'DD.MM.YYYY'
export const DATE_FORMAT_WITH_TIME = 'DD.MM.YYYY [в] HH:mm'
export const TIME_FORMAT = 'HH:mm'
export const DATE_FORMAT_EMPTY_TIME = 'YYYY-MM-DDTHH:mm:ss[Z]'

export const enum SEARCH_PARAMS {
  pickPointType = 'open_condition',
  latitude = 'latitude',
  longitude = 'longitude',
  subsidyHexType = 'subsidy_hex_type',
  mobileHash = 'mobile_hash',
  page = 'page',
  pageSize = 'pageSize',
}

export const VIDEO_FORMATS = ['mp4', 'mov']
export const PHOTO_FORMATS = ['jpeg', 'png', 'jpg']

export const VIDEO_VALIDATE = { allowedFileFormats: VIDEO_FORMATS, maxFileSizeMb: 100 }
export const PHOTO_VALIDATE = { allowedFileFormats: PHOTO_FORMATS, maxFileSizeMb: 20 }

export const CHECK_NETWORK_URL = 'https://www.wildberries.ru/'

export const widths = {
  mobile: 440,
  tablet: 768,
}
